module.exports = __webpack_public_path__ + "static/media/track.9c06a302.png";